<div class="form-group">
  <label class="control-label">
    <span class="form-label"
      *ngIf="label && label.length > 0">{{ label }}
      <span *ngIf="secondaryLabel"> - </span>
      <small>{{ secondaryLabel }}</small>
    </span>
    <div class="input-wrapper" [ngClass]="{'input-wrapper--focus': isFocus}">
      <i *ngIf="leftIcon" class="input-icon input-icon--left" [ngClass]="leftIcon"></i>
      <i *ngIf="cleanFieldIcon && !!value" class="input-icon input-icon--clean rx-close" @fadeIcon (click)="clickCleanIcon()"></i>
      <i *ngIf="rightIcon && !cleanFieldIcon" class="input-icon input-icon--right" [ngClass]="rightIcon"></i>
      <ng-container *ngIf="!group">
        <input class="form-control"
          #input
          [attr.type]="type"
          [attr.disabled]="disabled || null"
          [attr.readonly]="readonly || null"
          [attr.placeholder]="placeholder"
          [attr.autocomplete]="autocomplete"
          [attr.maxlength]="maxLength || null"
          [attr.minlength]="minLength || null"
          [ngClass]="{
            'disabled': disabled,
            'form-control--left-padding': leftIcon,
            'form-control--right-padding': rightIcon || cleanFieldIcon
          }"
          [disabled]="disabled"
          [(ngModel)]="value"
          (input)="onChange(input.value)"
          (focus)="onFocus($event)"
          (blur)="onBlur($event)"
          >
      </ng-container>
      <ng-container [formGroup]="group"
        *ngIf="group">
        <input class="form-control"
          #input
          [formControlName]="name"
          [attr.type]="type"
          [attr.disabled]="disabled || null"
          [attr.readonly]="readonly || null"
          [attr.placeholder]="placeholder"
          [attr.autocomplete]="autocomplete"
          [ngClass]="{
            'disabled': disabled,
            'form-control--left-padding': leftIcon,
            'form-control--right-padding': rightIcon || cleanFieldIcon
          }"
          [disabled]="disabled"
          (focus)="onFocus($event)"
          (blur)="onBlur($event)"
        >
      </ng-container>
    </div>
  </label>

  <ng-content select="[rx-help]"></ng-content>
  <ng-content select="[rx-error]"></ng-content>

  <div rx-error *ngIf="error" class="rx-error">{{ error }}</div>
  <div rx-help *ngIf="help" class="rx-help">{{ help }}</div>
</div>
